import { InputHTMLAttributes, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';
import { CountryCode } from 'libphonenumber-js';

import { FormBaseLabel } from './FormBaseLabel';
import { FormBaseError } from './FormBaseError';
import { FormPhoneInputSelect } from './FormPhoneInputSelect';

import { PhoneNumberService } from '../../services/PhoneNumberService';

import { usePhoneNumberMask } from '../../hooks/usePhoneMask';

const phoneNumberService = new PhoneNumberService();
const countryCodes = phoneNumberService.getAllCountryCodes();

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  id: string;
  error?: string;
  control: any;
  onPhoneChange: (cellphoneNumber: string[]) => void;
  initialCountryCode?: CountryCode | string;
}

const FormPhoneInput: React.FC<Props> = ({
  label,
  name,
  id,
  error,
  control,
  onPhoneChange,
  initialCountryCode = 'BR',
  ...rest
}) => {
  const { phoneMask, setCountryCode, countryCallingCode, countryCode } = usePhoneNumberMask(
    (initialCountryCode as CountryCode) || 'BR'
  );
  const [localPhoneNumber, setLocalPhoneNumber] = useState<string>('');

  useEffect(() => {
    if (initialCountryCode) {
      setCountryCode((initialCountryCode as CountryCode) || 'BR');
    }
  }, [initialCountryCode, setCountryCode]);

  if (!phoneMask) {
    console.error('Phone mask is undefined. Check usePhoneNumberMask logic.');
  }

  const handleCountryCodeChange = (countryCode: string) => {
    const selected = countryCodes.find((code) => code === countryCode) || '';
    setCountryCode((selected as CountryCode) || ('BR' as CountryCode));
  };

  return (
    <div className="flex w-full flex-col gap-1">
      <FormBaseLabel id={id} label={label} error={error} />

      <div className="flex w-full items-center gap-2">
        <FormPhoneInputSelect
          id={id}
          countryCodes={countryCodes}
          countryCode={countryCode}
          onCodeChange={handleCountryCodeChange}
        />

        <div className="flex h-[40px] w-full items-center rounded-lg border-[1px] border-[#CED4DA] bg-white px-3 text-sm text-slate-800 shadow-sm transition focus-within:border-blue-400 focus-within:ring-2 focus-within:ring-blue-500/40">
          <span className="w-auto whitespace-nowrap text-slate-500">+{countryCallingCode}</span>
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <ReactInputMask
                mask={phoneMask || ''}
                className="w-full pl-2 outline-none"
                {...field}
                {...rest}
                value={field.value || localPhoneNumber || ''} // Garante que seja uma string
                onChange={(e) => {
                  const value = e.target.value;
                  console.log('Phone Input Value:', value); // Verifica o valor ao digitar
                  setLocalPhoneNumber(value);
                  field.onChange(value);
                  onPhoneChange([countryCallingCode ?? '', value]);
                }}
                onBlur={() => {
                  console.log('Phone Input Blur:', field.value); // Verifica valor ao sair do campo
                }}
              />
            )}
          />
        </div>
      </div>

      {error && <FormBaseError error={error} />}
    </div>
  );
};

export { FormPhoneInput };
